import React from "react";

export default function Logo() {
  return (
    <img
      src='/assets/images/logo.svg'
      alt=''
      className='w-[160px] max-w-full h-auto'
    />
  );
}
